import { render, staticRenderFns } from "./DashboardCustomer.vue?vue&type=template&id=9ab5f62c"
import script from "./DashboardCustomer.vue?vue&type=script&lang=js"
export * from "./DashboardCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports